import React, { useState, useEffect } from 'react'
import { useLangContext } from '../context/lang.context'
import { alpha, colors, s } from '../style'
import { Link } from 'gatsby'

const content = {
  text: {
    pl: 'Przeglądając tę stronę, zgadzasz się na używanie plików Cookies. Więcej na',
    en: 'By browsing this website, you agree to the use of cookies. More on',
  },
  linkText: {
    pl: 'Polityka Prywatności',
    en: 'Privacy Policy',
  },
}

const PrivacyPopup = () => {
  const { lang } = useLangContext()
  const [isAccepted, setIsAccepted] = useState(true)

  const onAccept = () => {
    setIsAccepted(true)
    localStorage.setItem('cookies', JSON.stringify(true))
  }

  useEffect(() => {
    const cookiesAccepted = JSON.parse(localStorage.getItem('cookies'))
    setIsAccepted(!!cookiesAccepted)
  }, [])

  return (
    <div css={[sContainer, isAccepted && { display: 'none' }]}>
      <div
        css={sInner}
        onClick={onAccept}
        onKeyPress={onAccept}
        tabIndex={0}
        role='button'>
        {content.text[lang]}{' '}
        <Link to='/polityka-prywatnosci/'>{content.linkText[lang]}</Link>
        &nbsp;&nbsp;
        <button name='privacy'>OK</button>
      </div>
    </div>
  )
}

const sContainer = {
  pointerEvents: 'none',
  position: 'fixed',
  bottom: '2rem',
  right: '4rem',
  zIndex: 2001,
  display: 'flex',
  [s.sm_down]: {
    padding: 0,
    bottom: 0,
    right: 0,
  },
}

const sInner = {
  backgroundColor: colors.black.concat(alpha[25]),
  color: colors.white.concat(alpha[66]),
  backdropFilter: 'blur(16px)',
  fontSize: '0.75rem',
  padding: '1.5rem',
  width: 360,
  pointerEvents: 'auto',
  cursor: 'pointer',
  borderRadius: '1rem',
  [s.sm_down]: {
    borderRadius: '1rem 1rem 0 0',
    width: '100vw',
    padding: '1.5rem 2rem',
  },

  a: {
    color: colors.white.concat(alpha[100]),
    textDecoration: 'underline',
  },

  button: {
    height: 'max-content',
    width: 'max-content',
    appearance: 'none',
    border: 'none',
    outline: 'none',
    padding: '0.125rem 0.25rem',
    borderRadius: '0.25rem',
    fontWeight: 700,
    fontSize: '0.75rem',
  },
}

export default PrivacyPopup
